import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getActiveProducts } from "../services/storefrontProducts";
import { formatPrice } from "../data/products";
import { PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED } from "../config/featureFlags";

const Menu = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const loadProducts = async () => {
      setLoading(true);
      setError("");

      try {
        const rows = await getActiveProducts();
        if (!cancelled) {
          setProducts(rows);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Unable to load products.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadProducts();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="min-h-screen bg-[#f7fbef] px-4 py-24 text-slate-900 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 border-b border-lime-200 pb-6">
          <p className="text-sm font-bold uppercase tracking-[0.28em] text-red-700">
            Zea Mays Products
          </p>
          <h1 className="mt-2 text-3xl font-bold text-slate-950 sm:text-4xl">
            Product Menu
          </h1>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            Browse authentic Zea Mays food products and select a pack size to add to cart.
          </p>
        </div>

        {loading ? (
          <div className="rounded-3xl bg-white p-10 text-center text-slate-700 shadow-sm">Loading products…</div>
        ) : error ? (
          <div className="rounded-3xl bg-red-50 p-10 text-center text-red-700 shadow-sm">{error}</div>
        ) : products.length === 0 ? (
          <div className="rounded-3xl bg-white p-10 text-center text-slate-700 shadow-sm">No active products available.</div>
        ) : (
          <section className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {products.map((product) => {
              const startingPrice = Math.min(...(product.options || [{ price: product.price || 0 }]).map((option) => option.price));

              return (
                <Link
                  key={product.slug}
                  to={`/product/${product.slug}`}
                  className="group overflow-hidden rounded-lg border border-lime-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
                >
                  <img
                    src={product.image}
                    alt={product.title}
                    className="h-48 w-full object-cover transition duration-300 group-hover:scale-105"
                  />
                    <div className="p-4">
                    {PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED ? <p className="text-xs font-bold uppercase tracking-[0.18em] text-red-700">{product.business_line || "Pantry"}</p> : null}
                      <h2 className="text-lg font-bold text-slate-950">{product.name}</h2>
                    <p className="mt-2 line-clamp-2 text-sm leading-6 text-slate-600">
                      {product.description}
                    </p>
                    <div className="mt-4 flex items-center justify-between gap-3">
                      <span className="text-sm font-semibold text-slate-500">From</span>
                      <span className="font-bold text-red-700">{formatPrice(startingPrice)}</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </section>
        )}
      </div>
    </main>
  );
};

export default Menu;
